import { Provider } from 'react-redux'
import { StyledChart } from './components/chart';
import { store } from './redux';
import { useEffect } from 'react';
import { setAuthorize } from './redux/auth';
import ThemeProvider from './theme';
import Router from './routes';
import ScrollToTop from './components/scroll-to-top';
import CustomToast from './components/toast';
import Loader from './components/loader';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css'

export default function App() {
  useEffect(() => {
    const rememberAuth = localStorage.getItem("@remember")
    if (rememberAuth === "yes") {
      store.dispatch(setAuthorize(true))
    }
  }, [])
  return (
    <ErrorBoundary>
      <Provider store={store} >
        <ThemeProvider>
          <ScrollToTop />
          <StyledChart />
          <Router />
        </ThemeProvider>
        <CustomToast />
        <Loader />
      </Provider>
    </ErrorBoundary>
  );
}